<template>
  <div class="total-card justify-center align-center d-flex">
    <div class="d-flex flex-column justify-center align-center text-center">
      <v-icon size="80" color="#cccccc">mdi-alert-circle-outline</v-icon>
      <div class="my-4">
        요청하신 페이지를 찾을 수 없습니다.
      </div>
      <v-row class="ma-0 pa-0 justify-center align-center mt-4">
        <button @click="$router.go(-1)" class="px-4 py-3 rounded btn mr-8">
          이전 페이지로 이동
        </button>
        <router-link to="/login" class="px-4 py-3 rounded btn">
          로그인 페이지로 이동
        </router-link>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.total-card {
  font-family: "Noto Sans KR";
  width: 100%;
  height: 100%;
}
span {
  text-decoration: none;
  color: inherit;
}
.v-application a {
  color: black;
}
a {
  text-decoration: none;
  outline: none;
  color: black;
}

.btn {
  border: 1px solid #cccccc;
}
</style>
